import { render, staticRenderFns } from "./Pushes.vue?vue&type=template&id=c2b23676&scoped=true&"
import script from "./Pushes.vue?vue&type=script&lang=js&"
export * from "./Pushes.vue?vue&type=script&lang=js&"
import style0 from "./Pushes.vue?vue&type=style&index=0&id=c2b23676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b23676",
  null
  
)

export default component.exports